export default __webpack_public_path__ + "static/media/HardDriveImg.533264bc.jpg";